import { render, staticRenderFns } from "./advance-list.vue?vue&type=template&id=82489e7c&scoped=true"
import script from "./advance-list.vue?vue&type=script&lang=ts"
export * from "./advance-list.vue?vue&type=script&lang=ts"
import style0 from "./advance-list.vue?vue&type=style&index=0&id=82489e7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82489e7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82489e7c')) {
      api.createRecord('82489e7c', component.options)
    } else {
      api.reload('82489e7c', component.options)
    }
    module.hot.accept("./advance-list.vue?vue&type=template&id=82489e7c&scoped=true", function () {
      api.rerender('82489e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders-dispatches/advance-list.vue"
export default component.exports